/**
 * Plan configuration
 * Maps plans to entitlements (boolean capabilities) and quotas (numeric limits)
 * Plans are static configuration - not stored in database
 */
/**
 * Plan configurations for all subscription tiers
 */
export const PLANS = {
    free: {
        name: 'Free',
        entitlements: {
            'project.create': true,
        },
        quotas: {
            'projects.max': 1,
            'collaborators.org.max': 3,
        },
    },
    team: {
        name: 'Team',
        entitlements: {
            'project.create': true,
        },
        quotas: {
            'projects.max': 3,
            'collaborators.org.max': -1,
        },
    },
    lab: {
        name: 'Lab',
        entitlements: {
            'project.create': true,
        },
        quotas: {
            'projects.max': 10,
            'collaborators.org.max': -1,
        },
    },
    enterprise: {
        name: 'Enterprise',
        entitlements: {
            'project.create': true,
        },
        quotas: {
            'projects.max': -1,
            'collaborators.org.max': -1,
        },
    },
};
/**
 * Default plan ID for users without an active subscription
 */
export const DEFAULT_PLAN = 'free';
/**
 * Get plan configuration by plan ID
 * @param planId - Plan ID (e.g., 'free', 'team', 'lab')
 * @returns Plan configuration, or default plan if planId is invalid
 */
export function getPlan(planId) {
    if (planId in PLANS) {
        return PLANS[planId];
    }
    return PLANS[DEFAULT_PLAN];
}
/**
 * Check if a quota value represents unlimited quota
 * @param quota - Quota value to check
 * @returns True if quota is unlimited (value is -1)
 */
export function isUnlimitedQuota(quota) {
    return quota === -1;
}
/**
 * Get plan-like configuration for a grant type
 * Grants provide temporary access and map to specific quotas/entitlements
 */
export function getGrantPlan(grantType) {
    switch (grantType) {
        case 'trial':
            return {
                name: 'Trial',
                entitlements: {
                    'project.create': true,
                },
                quotas: {
                    'projects.max': 1,
                    'collaborators.org.max': 10,
                },
            };
        case 'single_project':
            return {
                name: 'Single Project',
                entitlements: {
                    'project.create': true,
                },
                quotas: {
                    'projects.max': 1,
                    'collaborators.org.max': 25,
                },
            };
        default:
            return PLANS[DEFAULT_PLAN];
    }
}
//# sourceMappingURL=plans.js.map